"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StationPageTopNav = void 0;
const react_1 = __importStar(require("react"));
const pectan_1 = require("./icons/pectan");
const environmentContext_1 = require("@geome/react-next/lib/context/environmentContext");
const linksList_1 = require("@geome/react-components-next/lib/components/linksList");
const react_next_1 = require("@geome/react-next");
const cross_1 = require("./icons/cross");
const hamburger_1 = require("./icons/hamburger");
const StationPageTopNav = ({ locationName, links = [], localeLinks = [], breadcrumbs = [], mobileOnlyLinks = [], }) => {
    const { isMobile } = (0, react_1.useContext)(environmentContext_1.EnvironmentContext);
    if (isMobile)
        return (react_1.default.createElement(StationPageTopNavMobile, { locationName: locationName, links: [...breadcrumbs, ...mobileOnlyLinks, ...links], localeLinks: localeLinks }));
    return (react_1.default.createElement("div", { className: "top-nav" },
        react_1.default.createElement("div", { className: "top-nav__logo" },
            react_1.default.createElement(pectan_1.PectenIcon, null)),
        react_1.default.createElement("nav", { className: "top-nav__text" },
            react_1.default.createElement(linksList_1.LinksList, { className: "top-nav__link", links: links }),
            react_1.default.createElement("div", { className: "top-nav__locales" },
                react_1.default.createElement(linksList_1.LinksList, { className: "top-nav__link top-nav__link--locale", links: localeLinks })))));
};
exports.StationPageTopNav = StationPageTopNav;
const StationPageTopNavMobile = ({ locationName, links, localeLinks, }) => {
    const [isMenuOpen, setIsMenuOpen] = (0, react_1.useState)(false);
    const [onToggleMenu] = (0, react_next_1.usePublishUserInteraction)("top-nav-mobile", "toggle");
    const { translate } = (0, react_next_1.useI18n)();
    return (react_1.default.createElement("div", { className: "top-nav top-nav--mobile" },
        react_1.default.createElement(pectan_1.PectenIcon, null),
        locationName,
        react_1.default.createElement("button", { className: `top-nav__menu-button ${isMenuOpen ? "top-nav__menu-button--open" : ""}`, onClick: () => {
                onToggleMenu({ open: !isMenuOpen });
                setIsMenuOpen((o) => !o);
            }, "aria-expanded": isMenuOpen, "aria-controls": "site-navigation", "aria-label": translate("aria.header.menu") }, isMenuOpen ? react_1.default.createElement(cross_1.CrossIcon, null) : react_1.default.createElement(hamburger_1.HamburgerIcon, null)),
        isMenuOpen && (react_1.default.createElement("div", { className: "top-nav__mobile-modal", "aria-modal": true },
            react_1.default.createElement("div", { className: "top-nav__locales top-nav__locales--mobile" },
                react_1.default.createElement(linksList_1.LinksList, { className: "top-nav__link top-nav__link--locale", links: localeLinks })),
            react_1.default.createElement(linksList_1.LinksList, { className: "top-nav__menu-link", links: links })))));
};
